import { SelectOption } from '@/types/form.type.ts';

export enum UserStatus {
    Active = 'active',
    Moderation = 'moderation',
    ModerationRejected = 'moderation_rejected',
    Deactivated = 'deactivated',
}

export function getUserStatusLabel(status: UserStatus): string {
    switch (status) {
        case UserStatus.Active:
            return 'Активен';
        case UserStatus.Moderation:
            return 'Ожидает модерации';
        case UserStatus.ModerationRejected:
            return 'Отклонен с модерации';
        case UserStatus.Deactivated:
            return 'Не активен';
    }
}

export function getUserStatusSelectOptions(): SelectOption[] {
    const options: SelectOption[] = [];

    Object.values(UserStatus).forEach((status: UserStatus) => {
        options.push({
            label: getUserStatusLabel(status),
            value: status,
        });
    });

    return options;
}
